import * as LucideIcons from 'lucide-react';
import { LayoutDashboard } from 'lucide-react';
import type { ComponentType } from 'react';

export type MenuIcon = ComponentType<{ className?: string }>;

/**
 * The icon component for a menu row's `icon` name. Names are free text in the menus
 * table, checked only here: an empty or unknown name falls back to the Dashboard icon,
 * exactly as the top bar has always drawn it.
 */
export function menuIcon(iconName: string | null | undefined): MenuIcon {
  if (!iconName) return LayoutDashboard;
  const found = (LucideIcons as unknown as Record<string, MenuIcon | undefined>)[iconName];
  return found || LayoutDashboard;
}
